<div class="MainDiv">
	<h4 *ngIf="SearchMode == 'Bus'">Search for Buses:</h4>
	<h4 *ngIf="SearchMode == 'Student'">Search for Students:</h4>

	<div class="OptionGrid2Col">
		<!--Type-->
		<label>Search By</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="SearchMode" [(ngModel)]="SearchMode" (ngModelChange)="onSearchModeChange($event)">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSearchMode" [ngValue]="o">
				{{ o }}
			</option>
		</select>

		<!----------------------------------------------------------------------------------------->
		<!--Bus-->
		<!----------------------------------------------------------------------------------------->
		<label *ngIf="SearchMode == 'Bus'">Has Alert:</label>
		<select *ngIf="SearchMode == 'Bus'" [disabled]="IsLoading() == true" class="form-control" name="HasAlertID" [(ngModel)]="HasAlertID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstHasAlert" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
		<!----------------------------------------------------------------------------------------->

		<!----------------------------------------------------------------------------------------->
		<!--Student-->
		<!----------------------------------------------------------------------------------------->
		<label *ngIf="SearchMode == 'Student'">School:</label>
		<p-dropdown
			*ngIf="SearchMode == 'Student'"
			[disabled]="IsLoading() == true"
			[options]="lstSchool"
			[(ngModel)]="School"
			optionLabel="SchoolName"
			[filter]="true"
			filterBy="SchoolFullName"
			[showClear]="false"
			placeholder="Select a School"
			(ngModelChange)="onSchoolChange($event)"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="School">
					<div class="form-control NoBorder" style="text-align: left">
						{{ School.SchoolFullName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-SchoolItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ SchoolItem.SchoolFullName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label *ngIf="SearchMode == 'Student'">Grade Level:</label>
		<p-dropdown
			*ngIf="SearchMode == 'Student'"
			[disabled]="IsLoading() == true"
			[options]="lstGradeLevel"
			[(ngModel)]="GradeLevel"
			optionLabel="GradeLevelDesc"
			[filter]="true"
			filterBy="GradeLevelDesc"
			[showClear]="false"
			placeholder="Select a Grade Level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="GradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevel.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GradeLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GradeLevelItem.GradeLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label *ngIf="SearchMode == 'Student'">Academy:</label>
		<p-dropdown
			*ngIf="SearchMode == 'Student'"
			[disabled]="IsLoading() == true"
			[options]="lstAcademy"
			[(ngModel)]="Academy"
			optionLabel="AcademyDesc"
			[filter]="true"
			filterBy="AcademyDesc"
			[showClear]="false"
			placeholder="Select an Academy"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="GradeLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Academy.AcademyDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-AcademyItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ AcademyItem.AcademyDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label *ngIf="SearchMode == 'Student'">Homeroom:</label>
		<p-dropdown
			*ngIf="SearchMode == 'Student'"
			[disabled]="IsLoading() == true"
			[options]="lstHomeroom"
			[(ngModel)]="Homeroom"
			optionLabel="HomeRoom"
			[filter]="true"
			filterBy="HomeRoom"
			[showClear]="false"
			placeholder="Select a Homeroom"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Homeroom">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Homeroom.HomeRoom }}
					</div>
				</div>
			</ng-template>
			<ng-template let-HomeroomItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ HomeroomItem.HomeRoom }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label *ngIf="SearchMode == 'Student'">Group:</label>
		<p-dropdown
			*ngIf="SearchMode == 'Student'"
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="Group"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupDesc"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="Group">
					<div class="form-control NoBorder" style="text-align: left">
						{{ Group.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupDescItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupDescItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>
		<!----------------------------------------------------------------------------------------->

		<!----------------------------------------------------------------------------------------->
		<!--Both-->
		<!----------------------------------------------------------------------------------------->

		<label>Active:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ActiveID" [(ngModel)]="ActiveID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstActive" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Filter</label>
		<input
			*ngIf="SearchMode == 'Bus'"
			class="form-control"
			type="text"
			placeholder="Bus number or desc."
			(keydown)="onFilterKeyDown($event)"
			[(ngModel)]="Filter"
		/>
		<!-- <input *ngIf="SearchMode == 'Student' " class="form-control" type="text" placeholder="Student name, ID or barcode" [(ngModel)]="Filter"> -->
		<input
			*ngIf="SearchMode == 'Student'"
			class="form-control"
			type="text"
			placeholder="Student name or ID"
			(keydown)="onFilterKeyDown($event)"
			[(ngModel)]="Filter"
		/>

		<!----------------------------------------------------------------------------------------->
	</div>

	<div class="Buttons">
		<button id="SearchButton" class="btn btn-primary" (click)="onSearch()">Search</button>
	</div>

	<!--Results-->
	<div *ngIf="SearchMode == 'Bus'">
		<caass-bus-selector-bus-results [lstBus]="lstBusSearchData" [TableLoading]="TableLoading" (SelectedChanged)="onBusSelectChange($event)">
		</caass-bus-selector-bus-results>
	</div>

	<div *ngIf="SearchMode == 'Student'">
		<caass-bus-selector-student-results [lstPerson]="lstStudentSearchData" [TableLoading]="TableLoading" (SelectedChanged)="onBusSelectChange($event)">
		</caass-bus-selector-student-results>
	</div>
</div>
